<template lang='pug'>
  <div id="app">
    #head
      #nav(ref='nav' v-if='getWSStatus') 
        #img
          img(src='/image/logo.png' )
        #menubar()
          template(v-for='item in menus')
              #MenuItem(@click='menuclick(item)') 
                span(:style='menuStyle(item.id)' ) {{item.title}} 
        #info()
          .icon() 
            img(src='/image/taobao.svg' onClick="window.open('https://shop222072978.taobao.com/search.htm?spm=a1z10.3-c.w4023-21930075118.27.460d13b7LxNgIn&orderType=hotsell_desc')")
            //span() 淘宝
          .icon() 
            img(src='/image/QQ.svg') 
            //span()  QQ
          .icon() 
            img(src='/image/wei.svg' @click="onWechat") 
            //span() 微信


      #navMB(ref='nav' v-if='!getWSStatus')
        img(width='70px' height='45px' src='/image/logo.png')
        #menuspac
        #menubut
          i(class='el-icon-menu'  @click='clickMenubut')
      //- transition(name="show")

      #subMenuBar(v-if='getWSStatus' :style="{height:subMenuHight+'px'}")
        template(v-for='subItem in subMenu.item')
          #subMenuItem(@click='subMenuClick(subItem.id)')
            img(:src='subItem.icon')
            a() {{subItem.title}} 
  
    #content
      <router-view/>

    #infobar
      #gs(style='flex-direction: column; align-items: center; justify-content: flex-start; display: flex; line-height: 20px;')
        a(href='http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020190823091331000004961957-SAIC_SHOW_310000-4028e4cb6c9a5291016e477493b00a6b277&signData=MEYCIQCFjFNvjg6eUQVccTL5eOF7QwTMJuy2omJwGFrPxEOhIwIhAOp6hCrCapDn5TFEH1dCuuvUd/w+zIhYiqY8pKgyAy0k' target="view_window")
          img(src='/image/lz.png' width='50px') 
        span(style='color:#fff;') 沪ICP备19010267号
      .hSpace()
      #i1
        p(style='font-size: 12pt;') 杭州微米测量技术有限公司
        p() 浙江省杭州市上城区丁兰街道临丁路669号东部软件城2幢
        p() Tel: +86 0571 5630 7287
        p() WebSite: http://u-meas.com.cn
        p() Email: sales@u-meas.com.cn
        p() QQ: 37370237

    el-dialog(:visible.sync='showMenu' :show-close='false' fullscreen  id='mainMenu')
      #dlgHeader(slot='title')
        i(class='el-icon-back' style='font-size:20px;color:#ededed;' @click='onMenuBack')
        #icon 
          .icon() 
            img(src='/image/taobao.svg'  onClick="window.open('https://shop222072978.taobao.com/search.htm?spm=a1z10.3-c.w4023-21930075118.27.460d13b7LxNgIn&orderType=hotsell_desc')"  ) 
          .icon() 
            img(src='/image/QQ.svg') 
          .icon() 
            img(src='/image/wei.svg' @click="onWechat") 
      #hLine()
      #dlgContent()
        .sMenu(v-for='item in menus')
          p() {{item.title}}
          .sMenuItem(v-for='v in item.item')
            img(:src='v.icon' width='35px')
            p() {{v.title}}

    el-dialog(:visible.sync='wechat_barcode'  id='batcode' :fullscreen='!getWSStatus' style='.el-dialog{max-width:600px !important;}' :model='false')
      span(slot='title' style='color:#333;') 请扫描下面的二维码
      #barcode() 
        .barItem()
          img(src='/image/wechat.jpg'  )
          span() 微信号
        .barItem()
          img(src='/image/wechat_public.jpg')
          span() 公众号

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import product from '../public/data/product.json'
import axios from 'axios'

export default {
  data(){
    return{
      wechat_barcode: false,
      isWidthScreen:false,
      showMenu:false,
      subMenuHight:0,
      subMenu:{},
      currMenuId:0,
      menus:[]  // product.menu.menus
    }
  },
  methods:{
    clickMenubut:function(){
      this.showMenu=true;
    },
    menuStyle:function(id){
      if(id == this.currMenuId){
        return {borderBottom:'1px solid #555',padding:'3px 0'}
      }
      return "";
    },
    onMenuBack:function(){
      this.showMenu=false;
    },
    onWechat:function(){
      this.wechat_barcode=true;
    },
    menuclick:function(item){
      this.currMenuId =item.id;
      this.$router.push(item.route);
      // if(item.item.length >0 ){
      //   // this.showSubMenu =true;
      //   this.subMenuHight=120;
      //   this.subMenu=item
      // }
      // else{
      //   // this.showSubMenu=false;
      //   this.subMenuHight=0,
      //   this.subMenu={};
      // }
      // console.log(item)
    },
    subMenuclick:function(id){

    }



  },
  computed:{
    ...mapGetters({
	            getWSStatus: 'getWSStatus',
	        }),
    wechatSize(){
      if(this.getWSStatus ){
        return "500px";
      }
      else{
        return "90%";
      }
    }
  },
  mounted:function(){
    // let _width= this.$refs.nav.clientWidth;
    // if(_width < 600){
    //   this.isWidthScreen=false;
    // }
    // else{
    //   this.isWidthScreen= true;
    // }
      // let script = document.createElement('script')
      // script.src = './data/product.json'
      // document.body.appendChild(script)
      axios({ url: './data/menu.json', method: 'get' }).then(res => {
        this.data = []
        if (res.data.menus) {
          this.menus=res.data.menus;
        }
      })
    
    window.addEventListener('resize',()=>{
        let _width= this.$refs.nav.clientWidth;
        console.log(_width);
        if(_width < 800){
          // this.isWidthScreen=false;
          this.$store.commit('setWS',false);
        }
        else{
          // this.isWidthScreen= true;
          this.$store.commit('setWS',true);
        }
    })
    if(this.$refs.nav.clientWidth< 800){
      this.$store.commit('setWS',false);
    }
  }
}
</script>


<style>
html{
  /* font-family:"Microsoft YaHei",微软雅黑; */
  
  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
  width:100%;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
}
html::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

.el-dialog.is-fullscreen{
  background-color: #333;
}

body{
  margin: 0px;
  width:100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-color: #fafafa;
}
</style>

<style lang="less" scoped>
@import "color";
#app {
  // font-family: Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #d7e7f7;
  // overflow: hidden;
  user-select: None;
  width:100%;
  max-width:  1920px;
}
#head{
  // position: sticky;
  // top: 0;
  border-bottom: 1px solid #ddd;
  background-color: #eb6622;
}

.hSpace{
  width:5%;
  height:100%;
}
#nav {
  width:calc(100% - 40px);
  height:150px;
  // background-color:#fafafa;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding:0 20px;
  // position:fixed;
  // max-width: 1326px;
  top:0;
  // * {
  //   // margin-right: 10px;
  // }

  #img{
    width:150px;
    height:90px;
    display:flex;
    flex-direction:column;
    justify-content:end;
    // margin-right:30px;
    // img{
    //   width:100%;
    //   height:100%;
    // }
  }
  #menubar{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items:flex-end;
  width: 100%;
  height:100%;
  margin-bottom: 10px;
    #MenuItem{
      transition: font-size 0.3s;
      color:#fff;
      padding:5px 15px;
      font-size:12pt;
      // font-weight:300;
    }
    #MenuItem:hover{
      color:#fff;
      font-size:14pt;
    }
  

    a {
      font-weight: bold;
      color: #2c3e50;
      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
}

.nav-menu{
  color:#fff;
  font-size:14px;
}
.el-icon-arrow-down{
  font-weight: 800;
  font-size:12px;
}
#func{
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

#info{
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size:8px;
  color:#ddd;
  justify-self: flex-end;
  .icon{
    width: 30px;
    height:80%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    margin: 0 10px;
    img:hover{
      width: 30px;
      height:30px;

    }
    img{
      width: 25px;
      height:25px;
    }
    &:hover{
      color:#f8b500;
    }
  }
}
#navMB{
  display: flex;
  background-color: @main_back_color;
  flex-direction: row;
  justify-content: center;
  align-items:center;
  width:calc(100% - 20px);
  height:80px;
  padding:5px 10px;
  
  #menuspac{
    flex-grow: 1;
  }

  #menubut{
    flex-grow: 0;
    flex-shrink: 1;
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    i{
      font-size:32px;
      color:#dedede;
    }
  }
}

#subMenuBar{
  // height:90px;
  transition: height 0.5s;
  width:100%;
  color:#eee;
  background-color: #555;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size:9pt;
  #subMenuItem:hover{
    border: 1px solid #ccc;
  }
  #subMenuItem{
    height: calc(100% - 20px);
    margin: 5px;
    padding:5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    img{
      width:75px;
      height:75px;
      margin: 5px 0;
    }

  }
}
#content{
  // margin-top: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

#dlgHeader{
  display: flex;
  flex-direction: row;
  background-color: #333;
  justify-content: space-between; 
  i{
    color:#dedede;
    font-size:32px;
    font-weight: 300;
  }
  #icon{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    .icon{
      width: 50px;
      height:32px;
      img{
        width: 24px;
        height:24px;
      }
    }
  }
}
#dlgContent{
  width:100%;
  background-color: #333;
}
.sMenu{
  width:100%;
  font-size:20px;
  color:#fff;
  p{
    text-align: left;
  }
  .sMenuItem{
    width:100%;
    height:40px;
    line-height: 40px;
    font-size:14px;
    display: flex;
    justify-content: flex-start;
    p{
      line-height:40px;
      margin-left:20px;
      width:100%;
      margin-block-end: 0;
      margin-block-start: 0;
    }
    &:hover{
      background-color:#2c3e50;
    }
  }
}
#hLine{
  width:100%;
  height:1px;
  background-color: #dedede;

}

#infobar{
  display: flex;
  flex-direction: row;
  width:calc(100% - 80px);
  height:220px;
  justify-content: center;
  background-color: #181818;
  color: #dfdfdf;
  font-size :9pt;
  padding:0 40px 0 40px;
  align-items: center;
  // line-height: 8px;

  #i1{
    display: flex;
    flex-direction: column;
    p{
      text-align: left;
      margin: 4px;
    }
  }
}

@media screen and (min-width: 800px){
  #barcode{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    img{
      width: 300px;
    }
    .barItem{
      display: flex;
      flex-direction: column;
    }
  }
}
@media screen and (max-width: 800px){
  #barcode{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img{
      width: 250px;
    }
    .barItem{
      display: flex;
      flex-direction: column;
    }
  }

}
</style>
